// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ISuggestRequest, TSuggestModel, IMappers, TSuggestResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISuggestV2Response } from '../../entities/entities/SuggestV2Response';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSuggestModel(parameters: ISuggestRequest): TSuggestModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'geo-suggest',
    pathApi: '/v2/suggest/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface ISuggestOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ISuggestRequest;
}

export async function fetchSuggest<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISuggestOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSuggestResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSuggestModel(parameters),
    config,
  )) as FetchResponse<TSuggestResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISuggestV2Response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSuggestResponse>;
}
